import actionTypes from '../../constants/actions/importarDireccionesExcel/importarDireccionesExcel'

export function submitImportarDireccionesExcel (value) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_DIRECCIONES_EXCEL,
    value
  }
}

export function submitImportarDireccionesExcelSuccess (listImportarDireccionesExcel) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_DIRECCIONES_EXCEL_SUCCESS,
    listImportarDireccionesExcel
  }
}

export function abrirModalImportarDireccionesExcel () {
  return {
    type: actionTypes.ABRIR_MODAL_IMPORTAR_DIRECCIONES_EXCEL
  }
}

export function cerrarModalImportarDireccionesExcel () {
  return {
    type: actionTypes.CERRAR_MODAL_IMPORTAR_DIRECCIONES_EXCEL
  }
}

export function subirArchivosImportarDireccionesExcel (archivoExcel) {
  return {
    type: actionTypes.SUBIR_ARCHIVOS_IMPORTAR_DIRECCIONES_EXCEL,
    archivoExcel
  }
}

export function descargarPlantillaExcelDireccionesExcel () {
  return {
    type: actionTypes.DESCARGAR_PLANTILLA_EXCEL_DIRECCIONES_EXCEL
  }
}

export default {
  submitImportarDireccionesExcel,
  abrirModalImportarDireccionesExcel,
  cerrarModalImportarDireccionesExcel,
  subirArchivosImportarDireccionesExcel,
  submitImportarDireccionesExcelSuccess,
  descargarPlantillaExcelDireccionesExcel
}